/**
 * @generated SignedSource<<5a18b6eb278f8fb947870448a11e78ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useVaultUploader_deleteDraftVaultItem_Mutation$variables = {
  draftVaultItemIds: ReadonlyArray<string>;
};
export type useVaultUploader_deleteDraftVaultItem_Mutation$data = {
  readonly deleteDraftVaultItems: {
    readonly draftUploadGroup: {
      readonly id: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly content: {
              readonly id?: string;
              readonly mimeType?: string;
              readonly name?: string;
            } | null;
            readonly id: string;
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"VaultUploaderFileCard_draftItem">;
          } | null;
        }>;
      };
    };
    readonly draftVaultItemDeletedIds: ReadonlyArray<string>;
  } | null;
};
export type useVaultUploader_deleteDraftVaultItem_Mutation = {
  response: useVaultUploader_deleteDraftVaultItem_Mutation$data;
  variables: useVaultUploader_deleteDraftVaultItem_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftVaultItemIds"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "draftVaultItemIds",
        "variableName": "draftVaultItemIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "draftVaultItemDeletedIds",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  (v3/*: any*/)
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "PendingFile",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/)
    ],
    "type": "File",
    "abstractKey": null
  },
  (v9/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVaultUploader_deleteDraftVaultItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VaultsDeleteDraftVaultItemsMutationPayload",
        "kind": "LinkedField",
        "name": "deleteDraftVaultItems",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultDraftUploadGroup",
            "kind": "LinkedField",
            "name": "draftUploadGroup",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultDraftItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VaultDraftItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaultDraftItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "VaultUploaderFileCard_draftItem"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useVaultUploader_deleteDraftVaultItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VaultsDeleteDraftVaultItemsMutationPayload",
        "kind": "LinkedField",
        "name": "deleteDraftVaultItems",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultDraftUploadGroup",
            "kind": "LinkedField",
            "name": "draftUploadGroup",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultDraftItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VaultDraftItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaultDraftItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cover",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Vault",
                            "kind": "LinkedField",
                            "name": "vault",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Member",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v11/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Thumbnail",
                                "kind": "LinkedField",
                                "name": "thumbnail",
                                "plural": false,
                                "selections": (v12/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Member",
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Vault",
                                    "kind": "LinkedField",
                                    "name": "vault",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "roles",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthorizationResult",
                                    "kind": "LinkedField",
                                    "name": "canUpdateSecurity",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "value",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "preventDownload",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasWatermark",
                                    "storageKey": null
                                  }
                                ],
                                "type": "HasNodeSecurityInterface",
                                "abstractKey": "__isHasNodeSecurityInterface"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "folderItemContent",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v14/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "FolderItem",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "vaultItemContent",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v14/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "VaultItem",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "draftVaultItemContent",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v14/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "VaultDraftItem",
                                "abstractKey": null
                              }
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63001542d185b23804c5c2e9ccacb13a",
    "id": null,
    "metadata": {},
    "name": "useVaultUploader_deleteDraftVaultItem_Mutation",
    "operationKind": "mutation",
    "text": "mutation useVaultUploader_deleteDraftVaultItem_Mutation(\n  $draftVaultItemIds: [ID!]!\n) {\n  deleteDraftVaultItems(input: {draftVaultItemIds: $draftVaultItemIds}) {\n    draftVaultItemDeletedIds\n    draftUploadGroup {\n      id\n      items {\n        edges {\n          node {\n            id\n            name\n            content {\n              __typename\n              ... on File {\n                id\n                name\n                mimeType\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on PendingFile {\n                id\n              }\n            }\n            ...VaultUploaderFileCard_draftItem\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SelectedVault_vault on Vault {\n  id\n  ...VaultAvatar_vault\n  name\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment VaultAvatar_vault on Vault {\n  id\n  name\n  members {\n    id\n    ...UserAvatar_member\n  }\n  thumbnail {\n    url\n  }\n}\n\nfragment VaultUploaderFileCard_draftItem on VaultDraftItem {\n  id\n  ...useNodeSecurity_node\n  cover\n  vault {\n    name\n    ...SelectedVault_vault\n    member {\n      id\n      name\n      email\n      vault {\n        id\n      }\n      ...UserHandle_member\n    }\n    id\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb58bfd418e955b3a478629771007cf1";

export default node;
